import styled from 'styled-components';

export const DocumentsContainer = styled.div`
    margin: 20px 0;
    padding: 20px;
    background: ${props => props?.theme?.palette?.white};
    border-radius: 8px;
    box-shadow: 0.5px 1px 2px rgba(0, 0, 0, 0.25);
`;

export const DocumentsTitle = styled.h3`
    color: #cc2250;
    margin-bottom: 15px;
    cursor: default;
`;

export const WithDate = styled.div`
    display: flex;
    align-items: center;
    color: #28a745;

    & > i
    {
        margin-right: 8px;
    }
`;

export const WithoutDate = styled.div`
    display: flex;
    align-items: center;
    color: #dc3545;
    font-size: 12px;

    & > i
    {
        margin-right: 8px;
    }
`;

export const SectionMargin = styled.div`
    margin-bottom: 15px;
    margin-top: -10px;
    cursor: default;
`;

export const SpinnerWithMargin = styled.span`
    margin-right: 10px;
`;

export const PromotionsLoadingRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
`;

export const DocumentsIntroText = styled.p`
    margin-bottom: 20px;
    color: #666;
    cursor: default;
`;

export const DocumentsSubtitle = styled.h4`
    color: #cc2250;
    margin-bottom: 10px;
`;

export const LoadingDocsContainer = styled.div`
    text-align: center;
    padding: 20px;
`;

export const LoadingDocsText = styled.p`
    margin-top: 10px;
`;

export const PromotionTitle = styled.strong`
    font-size: 16px;
`;

export const CardsRowWrapper = styled.div`
    width: 100%;
    display: flex;
    gap: 10px;
    margin-top: 15px;
    box-sizing: border-box;
`;

export const InternalSwitchCardContainer = styled.div`
    flex: 1;
    min-width: 0;
    box-sizing: border-box;
    background: ${props => props?.theme?.palette?.white};
    border-radius: 16px;
    box-shadow: 0.5px 1px 2px rgba(0, 0, 0, 0.25);
    padding: 20px;
    cursor: default;
`;

export const InternalSwitchCardTitle = styled.h4`
    padding-bottom: 18px;
    color: #cc2250;
`;

export const InternalSwitchCardContent = styled.div`
    display: flex;
    justify-content: flex-end;
    padding-bottom: 10px;
    font-size: 20px;
`;

export const InternalSwitchCardFooter = styled.div`
    color: #cc2250;
`;

export const InstantCalculationTitle = styled.h3`
    margin: 19px 0 10px 0;
    font-size: 20px;
    line-height: 28px;
    font-weight: 600;
    cursor: default;
`;

export const EstimatedCalculationIntroText = styled.p`
    margin: 0 0 15px 0;
    font-size: 14px;
    color: #605e5c;
    cursor: default;
    line-height: 1.4;
`;

export const CardsDisclaimerWrapper = styled.div`
    margin: 20px 0 0;
    padding: 12px 16px;
    border-radius: 12px;
    background: #FFF1BE;
    cursor: default;
`;

export const CardsDisclaimerText = styled.p`
    margin: 0;
    font-size: 13px;
    color: #F69A2D;
    line-height: 1.4;
    font-weight: 500;
`;

export const LoadingFundsWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 120px;
    padding: 20px 0;
`;